import { Box, Grid, useMediaQuery, useTheme } from "@mui/material";
import { LocalizationProvider } from '@mui/x-date-pickers';
import { DateRangePicker } from '@mui/x-date-pickers-pro';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import moment from 'moment';
import 'moment/locale/de';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import CustomActionBar from './CustomActionBar';
import MobileWheelTimePicker from './MobileWheelTimePicker';
import WheelTimePicker from './WheelTimePicker';

const DateRangeView = ({ startDate, setStartDate, setStartValue, endDate, setEndDate, setEndValue, shouldUpdate, setUpdated }) => {

    const theme = useTheme();
    const belowsm = useMediaQuery(theme.breakpoints.down("sm"));

    const [date, setDate] = useState([
        moment(),
        moment()
    ]);
    const [dateRange, setDateRange] = useState([
        moment(),
        moment()
    ])
    const [close, setClose] = useState(false);

    const { t } = useTranslation();

    useEffect(() => {
        if (moment(endDate).diff(moment(startDate), "hours") < 24 && shouldUpdate) {
            const startDateAsMoment = moment(startDate);
            const endDateForDateRange = moment(startDate);
            endDateForDateRange.add(1, "day");
            endDateForDateRange.add(moment(endDate).diff(moment(startDate), "minute"), "minute");
            setDate([
                startDateAsMoment,
                endDateForDateRange
            ]);
            setDateRange([
                startDateAsMoment,
                endDateForDateRange
            ]);
            setEndDate(endDateForDateRange);
            setEndValue(endDateForDateRange);
        }
        setDate([
            startDate,
            endDate
        ])
        setDateRange([
            startDate,
            endDate
        ])
        //eslint-disable-next-line
    }, [startDate, endDate])

    const setStartTime = (startTime) => {
        const newTime = moment(startTime);
        const newArr = [
            newTime,
            newTime.isAfter(date[1]) ? date[1].add(newTime.diff(date[0], "minute"), "minute") : date[1]
        ]
        setDate(newArr);
        setStartDate(newTime);
        setStartValue(newTime);
    };

    const setEndTime = (endTime) => {
        const newTime = moment(endTime);
        const newStartTime = moment(endTime);
        const isBefore = newTime.isBefore(date[0]);
        if (isBefore && newTime.format("HH:mm") !== "00:00") {
            newStartTime.subtract(15, "minute");
        }
        const newArr = [
            isBefore ? newStartTime : date[0],
            newTime
        ]
        setDate(newArr);
        if (isBefore) {
            setStartDate(newStartTime);
            setStartValue(newStartTime);
        }
        setEndDate(newTime)
        setEndValue(newTime);
    };

    const Seperator = () => {

        return (
            <Box
                sx={{ display: 'inline-block', transform: 'scale(1.2)', pl: 1.5, pt: 1 }}
            >
                _
            </Box>
        )
    };

    return (
        <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale={localStorage.getItem("i18nextLng")}>
            <Grid
                item
                xs={3}
                sx={{
                    p: 1,
                    pb: 2,
                    ml: 1
                }}
            >
                <Grid container>
                    <Grid item xs={12}>
                        <DateRangePicker
                            localeText={{
                                start: t("startdate"),
                                end: t("enddate")
                            }}
                            format="DD.MM.YYYY"
                            value={dateRange}
                            onChange={(newDate) => {
                                setDateRange(newDate);
                            }}
                            onOpen={() => { setClose(true); }}
                            onClose={() => { setClose(false); }}
                            onAccept={(finalDate) => {
                                const start = moment(finalDate[0]);
                                start.set("hour", date[0].hour());
                                start.set("minute", date[0].minute());
                                setStartDate(start);
                                setStartValue(start);
                                if (finalDate[1]) {
                                    const end = moment(finalDate[1]);
                                    end.set("hour", date[1].hour());
                                    end.set("minute", date[1].minute());
                                    setEndDate(end)
                                    setEndValue(end);
                                } else {
                                    const newEndDate = finalDate[0];
                                    newEndDate.set("hour", moment(startDate).hours()).add(1, "day");
                                    setEndDate(newEndDate);
                                    setEndValue(newEndDate);
                                }
                                if (setUpdated) {
                                    setUpdated(true);
                                };
                            }}
                            slots={{
                                actionBar: CustomActionBar,
                            }}
                            slotProps={{
                                desktopPaper: {
                                    sx: {
                                        backgroundImage: "none"
                                    }
                                },
                                mobilePaper: {
                                    sx: {
                                        pt: 2,
                                        borderRadius: 6,
                                        backgroundImage: "none"
                                    }
                                },
                                textField: {
                                    InputLabelProps: {
                                        shrink: true
                                    }
                                },
                                toolbar: {
                                    hidden: true
                                }
                            }}
                        />
                    </Grid>
                </Grid>
            </Grid>
            <Grid
                item
                xs={3}
                sx={{
                    p: 1,
                    pt: 0,
                    ml: 1,
                }}
            >
                <Grid container>
                    <Grid item xs={5.5} sx={{ pr: .5 }}>
                        {
                            belowsm ?
                                <MobileWheelTimePicker label={t("start-time")} time={date[0]} setTime={setStartTime} setUpdated={setUpdated} /> :
                                <WheelTimePicker label={t("start-time")} value={date[0]} setValue={setStartTime} close={close} setUpdated={setUpdated} />
                        }
                    </Grid>
                    <Grid item xs={1} sx={{ visibility: "hidden" }}>
                        <Seperator />
                    </Grid>
                    <Grid item xs={5.5} sx={{ pl: .5 }}>
                        {
                            belowsm ?
                                <MobileWheelTimePicker label={t("end-time")} time={date[1]} setTime={setEndTime} setUpdated={setUpdated} /> :
                                <WheelTimePicker label={t("end-time")} value={date[1]} setValue={setEndTime} close={close} setUpdated={setUpdated} />
                        }
                    </Grid>
                </Grid>
            </Grid>
        </LocalizationProvider>
    );

};

export default DateRangeView;